import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    constructor(private messageService: MessageService) { }

    showSuccess(message: string) {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
    }

    showError(message: string) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
    }

    // Routes to the key="html" toast, which renders `detail` as HTML (e.g. a clickable link).
    // Only pass app-controlled/trusted strings — never unsanitized user input.
    showErrorHtml(message: string) {
        this.messageService.add({ key: 'html', severity: 'error', summary: 'Error', detail: message });
    }

    showInfo(message: string) {
        this.messageService.add({ severity: 'info', summary: 'Info', detail: message });
    }

    showWarn(message: string) {
        this.messageService.add({ severity: 'warn', summary: 'Warn', detail: message });
    }
}